import { styled } from 'opensolar-ui'
import { FC } from 'react'

interface TaglineData {
  text?: string
  whiteText?: boolean
}
interface PropTypes {
  logoUrl?: URL
  tagline?: TaglineData
  backgroundUrl?: URL
}

const CoverWrapper = styled('div', { name: 'CoverWrapper' })<{ backgroundUrl: string }>(({ backgroundUrl, theme }) => ({
  height: 200,
  backgroundImage: backgroundUrl ? `url("${backgroundUrl}")` : '',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center left',
  paddingLeft: 30,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: backgroundUrl ? '' : 'white',
  [theme.breakpoints.down('md')]: {
    height: 150,
  },
  [theme.breakpoints.down('sm')]: {
    height: 100,
  },
}))

const CoverLogo = styled('img', { name: 'CoverWrapper' })(({ theme }) => ({
  marginRight: 'auto',
  maxHeight: 80,
  maxWidth: 150,
  [theme.breakpoints.down('sm')]: {
    maxHeight: 30,
    maxWidth: 80,
  },
}))
const CoverTagline = styled('p', {
  name: 'CoverTagline',
  shouldForwardProp: (prop) => prop !== 'white',
})<{ white?: boolean }>(({ white, theme }) => ({
  marginBottom: 0,
  marginTop: 20,
  fontSize: 32,
  color: white ? 'white' : 'black',
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
  },
}))

const Cover: FC<PropTypes> = ({ logoUrl, tagline, backgroundUrl }) => {
  return (
    <CoverWrapper backgroundUrl={backgroundUrl?.toString() || ''}>
      <CoverLogo src={logoUrl?.toString()} />
      <CoverTagline white={tagline?.whiteText}>{tagline?.text}</CoverTagline>
    </CoverWrapper>
  )
}

export default Cover
